import { ELITE_SECTION_NAMES } from "../../../constants/luxury-cars-constants";
import EliteHowItWorks from "../elite-how-it-works";
import EliteWhyChoose from "../elite-why-choose";
import EliteStores from "../elite-stores";
import EliteNumbers from "../elite-numbers";
import EliteFaq from "../elite-faq";
import EliteGetBestPrice from "../elite-get-best-price";
import EliteTestimonials from "../elite-testimonials";

export const COMPONENT_MAPPING = {
    [ELITE_SECTION_NAMES.ELITE_HOW_IT_WORKS]: EliteHowItWorks,
    [ELITE_SECTION_NAMES.WHY_CHOOSE_ELITE]: EliteWhyChoose,
    [ELITE_SECTION_NAMES.ELITE_STORES]: EliteStores,
    [ELITE_SECTION_NAMES.ELITE_NUMBERS]: EliteNumbers,
    [ELITE_SECTION_NAMES.ELITE_FAQ]: EliteFaq,
    [ELITE_SECTION_NAMES.ELITE_GET_BEST_PRICE]: EliteGetBestPrice,
    [ELITE_SECTION_NAMES.ELITE_USER_EXPERIENCE]: EliteTestimonials
};
